import React, { FC, useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { Rx } from '../../services/Rx';
import Firebaser from '../../services/Firebaser';
import { MeetingPreview } from '../../model/meetingPreview';
import { Check } from '@material-ui/icons';

interface Props {
    meeting: MeetingPreview;
}

export const DeliveredToClientButton: FC<Props> = ({meeting}) => {
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const func = async () => setIsAdmin(await Firebaser.isAdmin(Rx.ConnectedUserId.value))
        func();
    }, []);

    if(!isAdmin)
        return <></>;

    const onCheck = () => {
        const shouldSetReady = !meeting.dateOfReady;

        meeting.deliveredToClient = !meeting.deliveredToClient;
        if(shouldSetReady)
            meeting.dateOfReady = new Date();

        Rx.Meetings.next([...Rx.Meetings.value]);

        Firebaser.setDelivered(meeting.id, meeting.deliveredToClient, meeting.assignedTo);
        if(shouldSetReady)
            Firebaser.setReady(meeting.id, meeting.assignedTo, meeting.dateOfReady);
    };

    const buttonColor = !!meeting.deliveredToClient ? "green" : "gray";

    return <Button onClick={onCheck}
                   style={{backgroundColor: buttonColor, color: "white", marginRight: '0.5em', width: 125}}
                   className="deliveredClient"
            >
                {!!meeting.deliveredToClient && <Check style={{marginLeft: '0.1em'}}/>}
                <span>נשלח ללקוח</span>
            </Button>
}
